<div class="twc-m-2 layer-options">
    <h1 class="twc-h1">{{ 'WIZARD.TAB_LAYER_OPTIONS' | translate }}</h1>

    <form [formGroup]="uploadWizardService.layerForm" class="twc-form twc-mt-4">
        <div class="twc-form-control twc-col-lg-6 twc-col-md-12">
            <label for="name" class="twc-form-label font-bold">{{ 'CREATE_PROJECT.LAYER_NAME' | translate }}</label>
            <div class="twc-form-element">
                <input id="name" formControlName="name" class="twc-input" required [maxLength]="defaultMaxLength">
            </div>
            <div class="twc-mt-2">
                <div class="twc-form-error twc-d-block" qaid="new-layer_form-input-name_error"
                    *ngIf="uploadWizardService.layerForm.get('name')?.hasError('required')">
                    {{'UPLOAD.NAME_REQUIRED' | translate}}
                </div>
            </div>
        </div>
    </form>

    <div class="twc-row" *ngIf="isCsvGeometry">
        <div class="twc-col-lg-3 twc-col-md-6 twc-col-sm-12">
            <label class="twc-form-label font-bold">{{'UPLOAD.CSV_GIS_IMPORTER_SELECT_TYPE' | translate}}</label>
            <twc-select [(ngModel)]="gisConversion.csvType">
                <twc-select-option *ngFor="let option of csvTypes" [value]="option">
                    {{'UPLOAD.CSV_GIS_IMPORTER_CONTROL_POINT_' + option | translate }}
                </twc-select-option></twc-select>
        </div>
        <div class="twc-col-lg-3 twc-col-md-6 twc-col-sm-12">
            <label class="twc-form-label font-bold">{{'UPLOAD.CSV_GIS_IMPORTER_SELECT_SCALE_FACTOR' |
                translate}}</label>
            <twc-select [(ngModel)]="gisConversion.ScaleFactor">
                <twc-select-option *ngFor="let option of scaleFactorDefinitions" [value]="option.fromMeters">
                    {{ option.label | translate}}
                </twc-select-option>
            </twc-select>
        </div>
    </div>
</div>